import React from "react";
import { CtaButton } from "../CtaButton";
import { authorQuestions, images } from "../../data/landing";
export function AuthorMessage() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-83" data-mp="2h2lgv4d7p7u4">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[minmax(0,380px)_1fr] md:items-start" data-id="element-84" data-mp="2lwg0y8wqbotq">
        <figure className="md:sticky md:top-8" data-id="element-85" data-mp="2qt6eaoh5g6bg">
          <img src={images.author} alt="Dr. Michael Carter" className="w-full rounded-3xl object-cover ring-4 ring-gold/60" loading="lazy" data-id="element-86" data-mp="1t6qwtmoq38nw" />
          <figcaption className="mt-4 text-center" data-id="element-87" data-mp="1y6vcxblpy1dl">
            <span className="block font-serif text-2xl font-bold text-gold" data-id="element-88" data-mp="234wvzwj5a0p2">Dr. Michael Carter</span>
            <span className="text-sm text-white/70" data-id="element-89" data-mp="28401tj6y8ay3">Creator of Lipo Planning Workbook™</span>
          </figcaption>
        </figure>

        <div data-id="element-90" data-mp="3ekv8ybhg16vk">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-91" data-mp="3ejafkp6v7tza">A message from Dr. Michael Carter</p>
          <h2 className="mt-3 font-serif text-[1.9rem] font-extrabold italic leading-tight sm:text-4xl" data-id="element-92" data-mp="3jhby990dpra8">
            "I didn't create another liposuction course."
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-white/80" data-id="element-93" data-mp="2dlm7cpq5f3l5">
            <p data-id="element-94" data-mp="29i6em4h79ndq">
              I've spent years studying how professionals approach cases and how experienced clinicians organize information before
              making decisions. One thing became increasingly clear:
            </p>
            <p className="font-serif text-xl font-semibold text-white" data-id="element-95" data-mp="1zm32c5smw8d2">
              Knowing more information and knowing how to organize that information are not the same thing.
            </p>
            <p data-id="element-96" data-mp="1pvi44jgvh5uo">
              You can read another paper, watch another demonstration, attend another conference. But eventually, you have to sit
              down with a case and practice your thinking.
            </p>
            <p data-id="element-97" data-mp="1gwdbtuvwm8qy">I wanted something you could open before reviewing a case and immediately know:</p>
          </div>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-98" data-mp="127lb0cv1ug0j">
            {authorQuestions.map(q => <li key={q} className="rounded-xl bg-white/[0.07] px-4 py-3 font-semibold text-gold-light" data-id="element-99" data-mp="176oie3yi4ybo">
                {q}
              </li>)}
          </ul>
          <p className="mt-6 font-serif text-2xl font-bold text-gold" data-id="element-100" data-mp="sbib7dno6tgr">Don't just consume information. Practice organizing it.</p>
          <div className="mt-5 space-y-4 text-[16px] leading-relaxed text-white/75" data-id="element-101" data-mp="1kycsk1p6xcq0">
            <p data-id="element-102" data-mp="1l0fjqp22xbwb">
              It isn't intended to replace formal surgical training, mentorship, supervision, current evidence, institutional protocols
              or professional judgment. It's a case-based educational tool.
            </p>
            <p data-id="element-103" data-mp="1g6b8vupp0jpy">If you're serious about becoming more disciplined in the way you review and plan liposuction cases, I built this for you.</p>
          </div>
          <p className="mt-5 font-serif text-xl italic text-white" data-id="element-104" data-mp="23v4b28wwrnt0">— Dr. Michael Carter</p>
          <div className="mt-10" data-id="element-105" data-mp="28pi8egv4s50b">
            <CtaButton label="I want access to Lipo Planning Workbook™" data-id="element-106" data-mp="3tdj6ffca3mf4" />
          </div>
        </div>
      </div>
    </section>;
}